import React from 'react';

function Logo(props) {
  return <img alt="Logo" src="/static/carry1stlogoBlue.png" width="128" height="32" {...props} />;
}

export default Logo;
